import React from 'react';
import { DateTitleSC } from './date-title.styled';
import classNames from 'classnames';

interface DateTitleProps {
  day?: string;
  month?: string;
  year?: string;
  onDayClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMonthClick?: React.MouseEventHandler<HTMLButtonElement>;
  onYearClick?: React.MouseEventHandler<HTMLButtonElement>;
}

const DateTitle: React.FunctionComponent<DateTitleProps> = ({
  day,
  month,
  year,
  onDayClick,
  onMonthClick,
  onYearClick,
}) => {
  return (
    <DateTitleSC>
      {day ? (
        <button
          className={classNames('day-title', { clickable: !!onDayClick })}
          onClick={onDayClick}
        >
          {month}
        </button>
      ) : null}
      {month ? (
        <button
          className={classNames('month-title', { clickable: !!onMonthClick })}
          onClick={onMonthClick}
        >
          {month}
        </button>
      ) : null}
      {year ? (
        <button
          className={classNames('year-title', { clickable: !!onYearClick })}
          onClick={onYearClick}
        >
          {year}
        </button>
      ) : null}
    </DateTitleSC>
  );
};

export default DateTitle;
